webpackJsonp([35],{

/***/ "EStm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/salma-webinars_8cd9637562482636f7fe8d06388dd5d8.html";

/***/ }),

/***/ "MnpC":
/***/ (function(module, exports, __webpack_require__) {

var salmaWebinars = (function () {
    function salmaWebinars() {
    }
    return salmaWebinars;
}());
angular.module('animatronApp.wave.salmaWebinars', []).component('salmaWebinars', {
    controller: salmaWebinars,
    templateUrl: __webpack_require__("EStm")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/35-bd880478516a225297ea.min.js